// extracted by mini-css-extract-plugin
export var cartContainer = "_kg-4";
export var gray = "_kg-1";
export var itemContainer = "_kg-2";
export var itemDetails = "_kg-3";
export var strong = "_kg-0";